import { Component, computed, inject, input, signal } from '@angular/core';
import { ConnectionType, RelayService, TranslationPipe } from '@cloud-and-service/portal-lib';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ConnectivityResult } from 'projects/portal-lib/src/lib/models/connectivity-result.model';

@Component({
  selector: 'app-admin-connectivity-test',
  imports: [PopoverModule, TranslationPipe],
  templateUrl: './admin-connectivity-test.component.html',
  styleUrl: './admin-connectivity-test.component.scss',
})
export class AdminConnectivityTestComponent {
  relayService = inject(RelayService);

  tenantId = input.required<string | null>();
  connectionType = input.required<ConnectionType>();
  allowTest = input<boolean>(false);
  testResult = signal<ConnectivityResult | null>(null);

  disabled = computed(() => {
    return !this.allowTest() || !this.tenantId();
  });

  async testConnection() {
    const result = await this.relayService.connectivityTest(this.tenantId()!, this.connectionType());
    this.testResult.set(result);
  }
}
